/** QR for https://moova.tv/activation (version 3, error correction M), generated once with the `qrcode` package; 1 = dark module. */
export const QR = { size: 29, text: 'https://moova.tv/activation', rows: [
  '11111110001110011011101111111',
  '10000010010000000010001000001',
  '10111010100100101001101011101',
  '10111010101010001100101011101',
  '10111010101011110001101011101',
  '10000010110101111000101000001',
  '11111110101010101010101111111',
  '00000000110001010010000000000',
  '10111110001110110101001111100',
  '10100100101010011111111110001',
  '11110110111000000010010000000',
  '10000000111100101000100111010',
  '11000111000010001100110101100',
  '10010001110011110111111110001',
  '00010111011011111100101101100',
  '11001101000111010001011100010',
  '01010110001010110100000001100',
  '10101100110000011111101110101',
  '10101110100100000100100100100',
  '10100100110010101010010100010',
  '10010010000010001010111110111',
  '00000000110011110110100011111',
  '11111110000111111101101011100',
  '10000010110011010111100010001',
  '10111010100000110000111110111',
  '10111010100001011011100001100',
  '10111010100110100011101111110',
  '10000010000101101000100111010',
  '11111110110010001010011100100',
] };
